export default function ArtworkCard({ artwork, onClick, printDate }) {
  const printYear = printDate.split("-")[0];

  return (
    <div onClick={onClick} className="group relative cursor-pointer w-full animate-slide-up">
      {/* image frame */}
      <div className="aspect-[3/4] w-full bg-collectors-light mb-3 relative overflow-hidden transition-all duration-300">
        <img
          src={artwork.image}
          alt={artwork.title}
          className="w-full h-full object-cover group-hover:scale-[1.05] transition-all duration-300"
        />
        {/* overlay on hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
          <span className="opacity-0 group-hover:opacity-100 bg-black text-white font-mono text-xs p-2 uppercase">
            View Certificate
          </span>
        </div>
      </div>
      {/* metadata */}
      <div className="flex justify-between items-start border-t border-collectors-black pt-2 border-solid">
        <div className="flex flex-col">
          <h3 className="font-display font-bold text-lg uppercase leading-tight">
            {artwork.title}
          </h3>
          <p className="font-mono text-xs uppercase text-collectors gray">{artwork.artist}</p>
        </div>
        <span className="font-mono text-xs border border-solid border-oditi-black p-1 rounded-sm">
          {printYear || "2025"}
        </span>
      </div>
    </div>
  );
}
